'use client'
import React, { useState } from 'react'
import AngleDownIcon from '@/icons/font-awesome/sharp-light/angle-down.svg'

export function HotelDescriptionShort(props: {
  hotelDescriptionShort: string
  showMorelabel: string
}) {
  const [showFullDescription, setShowFullDescription] = useState(false)

  function handleShowMoreClick() {
    setShowFullDescription(true)
  }

  return (
    <>
      <p
        className={`text-sm text-stone-800 ${!showFullDescription && props.hotelDescriptionShort.length > 400 ? 'mb-1 line-clamp-3' : 'mb-6'}`}
      >
        {props.hotelDescriptionShort}
      </p>
      {props.hotelDescriptionShort.length > 400 && !showFullDescription && (
        <button
          className="flex items-center text-sm text-stone-800 underline "
          onClick={handleShowMoreClick}
        >
          {props.showMorelabel} <AngleDownIcon className="ml-1 mt-1.5 h-3 w-3 fill-stone-800" />
        </button>
      )}
    </>
  )
}
